import { css } from '@inter-ikea-kompis/web-component';
import { ProductRowLayoutEnum } from '@inter-ikea-kompis/component-product-row';
import { Text } from '@ingka/common-styles-webc';
export default class ProductListSectionStyle {
    /**
     * Returns styles.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @param options.layout ProductRowLayout enum.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			${Text.CSS}

			:host {
				display: block;
			}

			.label {
				display: flex;
				align-items: center;
				margin-bottom: ${options.layout === ProductRowLayoutEnum.compactPrint
            ? spacing.space50 / 16
            : 0}rem;
			}

			.label h2 {
				margin: 0;
			}

			.badge {
				margin-left: ${spacing.space100 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=ProductListSectionStyle.js.map